import React from "react";
import { useTranslation } from "../i18n";

export default function Legal() {
  const { t } = useTranslation();

  return (
    <section className="container mx-auto px-6 py-20">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">
          {t("legal.title")}
        </h1>

        <div className="bg-white border rounded-2xl shadow-sm p-8 space-y-6">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              Éditeur du site
            </h2>
            <p className="text-gray-600">
              Van-2-Go.ch<br />
              Jura, Suisse<br />
              Email: info@van-2-go.ch/<br />
              Tél: +41 79 960 60 94
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              Hébergement
            </h2>
            <p className="text-gray-600">
              À compléter selon votre hébergeur
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              Données personnelles
            </h2>
            <p className="text-gray-600">
              Les données collectées via ce site sont utilisées uniquement 
              dans le cadre de la gestion des réservations et ne sont pas 
              transmises à des tiers.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-3">
              Cookies
            </h2>
            <p className="text-gray-600">
              Ce site n'utilise pas de cookies de tracking.
            </p>
          </div>

          <div className="pt-6 border-t">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-CH')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}